import moment from 'moment';
import {
    roundTimeEndDay,
    roundTimeStartDay,
    roundTimeStartSecond,
} from 'pages/manager-meeting/functions';

export const toTimestamp = (value) => value == null ? value : moment(value).valueOf();
export const toApiPeriodDate = (value) => value == null ? null : moment(value);

export const createInitialPeriodState = ({ endSecond }) => ({
    time_profile_type_id: null,
    start_time: null,
    end_time: null,
    interval: null,
    day: null,
    week: null,
    isChangePeriod: null,
    start: toTimestamp(roundTimeStartDay()),
    startSecond: roundTimeStartSecond(),
    end: toTimestamp(roundTimeEndDay()),
    endSecond: endSecond(),
    isOpenModalDetail: false,
    isOpenModalCancel: false,
    roomId: '',
});
